<!--
 * @Autor: Sakurag1_LSJ
 * @LastEditors: Lvshijie
-->
<template>
  <div class="result">
    <!-- <div style="margin: 15px; margin: 0 auto; width: 80%; text-align: center">
      <h1>This is an result page</h1>
    </div> -->
    <div class="product-list-box" style="width: 70%; margin: 0 auto">
      <div class="product-list-item">
        <div id="maize" class="cursor" @click="changeType('maize')">
          <img src="../assets/picture/yumiICON.png" alt="Icon" />
          <h5>Maize</h5>
        </div>
      </div>

      <div class="product-list-item">
        <div id="rice" class="cursor" @click="changeType('rice')">
          <img
            src="../assets/picture/southeast-removebg-preview.png"
            alt="Icon"
          />
          <h5>Rice</h5>
        </div>
      </div>
      <div class="product-list-item">
        <div id="cotton" class="cursor" @click="changeType('cotton')">
          <img src="../assets/picture/mianhuaICON.png" alt="Icon" />
          <h5>Cotton</h5>
        </div>
      </div>
      <div class="product-list-item">
        <div id="wheat" class="cursor" @click="changeType('wheat')">
          <img src="../assets/picture/xiaomaiICON.png" alt="Icon" />
          <h5>Wheat</h5>
        </div>
      </div>
    </div>
    <div v-loading="Loading">
      <div class="table" v-if="type == 'maize'">
        <div>
          <div class="top wrap1">
            <h1 style="font-size: 40px; font-weight: bold; color: #003164">
              Promoter proximal region interaction
            </h1>
            <!-- </div> -->
          </div>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">PPI PREDICTION RESULTS</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="Ear(Li et al. 2019)">
                  <Table :tdata="predictions_ppi_ear"></Table>
                </el-tab-pane>
                <el-tab-pane label="Ear(Sun et al. 2020)">
                  <Table :tdata="predictions_ppi_in_ear"></Table>
                </el-tab-pane>
                <el-tab-pane label="Tassel(Sun et al. 2020)">
                  <Table :tdata="predictions_ppi_in_tassel"></Table>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Peng et al. 2019)">
                  <Table :tdata="predictions_ppi_in_py"></Table>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Li et al. 2019)">
                  <Table :tdata="predictions_ppi_in_shoot"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">PPI Interaction Information</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="Ear(Li et al. 2019)">
                  <Table :tdata="ear"></Table>
                </el-tab-pane>
                <el-tab-pane label="Ear(Sun et al. 2020)">
                  <Table :tdata="in_ear"></Table>
                </el-tab-pane>
                <el-tab-pane label="Tassel(Sun et al. 2020)">
                  <Table :tdata="in_tassel"></Table>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Peng et al. 2019)">
                  <Table :tdata="py"></Table>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Li et al. 2019)">
                  <Table :tdata="shoot"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">The Result Of PPI</span>
            </div>
            <div>
              <el-tabs
                tab-position="top"
                stretch
                @tab-click="changePPIFileList"
              >
                <el-tab-pane label="Ear(Li et al. 2019)">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Ear(Sun et al. 2020)">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Tassel(Sun et al. 2020)">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Peng et al. 2019)">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Li et al. 2019)">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <div class="top wrap1">
            <!-- <div class="box box1"> -->
            <h1 style="font-size: 40px; font-weight: bold; color: #003164">
              Promoter distal element interaction
            </h1>
            <!-- </div> -->
          </div>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">PDI PREDICTION RESULTS</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch class="resTabs">
                <el-tab-pane label="Ear(Li et al. 2019)">
                  <Table :tdata="maize_pdi_pre_ear"></Table>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Peng et al. 2019)">
                  <Table :tdata="maize_pdi_pre_py"></Table>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Li et al. 2019)">
                  <Table :tdata="maize_pdi_pre_shoot"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">PDI Interaction Information</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch class="resTabs">
                <el-tab-pane label="Ear(Li et al. 2019)">
                  <Table :tdata="maize_pdi_res_ear"></Table>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Peng et al. 2019)">
                  <Table :tdata="maize_pdi_res_py"></Table>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Li et al. 2019)">
                  <Table :tdata="maize_pdi_res_shoot"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">The Result Of PDI</span>
            </div>
            <div>
              <el-tabs
                tab-position="top"
                stretch
                @tab-click="changePDIFileList"
              >
                <el-tab-pane label="Ear(Li et al. 2019)">
                  <FileNameTable :tdata="PDIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePDIChange"
                      :current-page.sync="currentPage2"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Peng et al. 2019)">
                  <FileNameTable :tdata="PDIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePDIChange"
                      :current-page.sync="currentPage2"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Shoot(Li et al. 2019)">
                  <FileNameTable :tdata="PDIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePDIChange"
                      :current-page.sync="currentPage2"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
      </div>
      <div class="table" v-if="type == 'rice'">
        <div>
          <div class="top wrap1">
            <h1 style="font-size: 40px; font-weight: bold; color: #003164">
              Promoter proximal region interaction
            </h1>
          </div>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">RICE PREDICTION RESULTS</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="MH_H3K4" :lazy="true">
                  <Table :tdata="rice_pre_MH_H3K4"></Table>
                </el-tab-pane>
                <el-tab-pane label="MH_H3K9" :lazy="true">
                  <Table :tdata="rice_pre_MH_H3K9"></Table>
                </el-tab-pane>
                <el-tab-pane label="MH_RNAP2" :lazy="true">
                  <Table :tdata="rice_pre_MH_RNAP2"></Table>
                </el-tab-pane>
                <el-tab-pane label="ZS_H3K4">
                  <Table :tdata="rice_pre_ZS_H3K4"></Table>
                </el-tab-pane>
                <el-tab-pane label="ZS_H3K9">
                  <Table :tdata="rice_pre_ZS_H3K9"></Table>
                </el-tab-pane>
                <el-tab-pane label="ZS_RNAP2">
                  <Table :tdata="rice_pre_ZS_RNAP2"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <div>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">RICE Interaction Information</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="MH63.H3K4me3" :lazy="true">
                  <Table :tdata="rice_res_MH63_H3K4me3"></Table>
                </el-tab-pane>
                <el-tab-pane label="MH63.H3K9me2" :lazy="true">
                  <Table :tdata="rice_res_MH63_H3K9me2"></Table>
                </el-tab-pane>
                <el-tab-pane label="MH63.RNAP2" :lazy="true">
                  <Table :tdata="rice_res_MH63_RNAP2"></Table>
                </el-tab-pane>
                <el-tab-pane label="ZS_H3K4">
                  <Table :tdata="rice_res_ZS_H3K4"></Table>
                </el-tab-pane>
                <el-tab-pane label="ZS_H3K9">
                  <Table :tdata="rice_pre_ZS_H3K9"></Table>
                </el-tab-pane>
                <el-tab-pane label="ZS_RNAP2">
                  <Table :tdata="rice_pre_ZS_RNAP2"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <el-card class="resTabs">
          <div slot="header">
            <span class="tableTitle">The Result Of Rice</span>
          </div>
          <div>
            <el-tabs tab-position="top" stretch @tab-click="changePPIFileList">
              <el-tab-pane label="MH34">
                <FileNameTable :tdata="PPIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePPIChange"
                    :current-page.sync="currentPage1"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="MH39">
                <FileNameTable :tdata="PPIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePPIChange"
                    :current-page.sync="currentPage1"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="MHP2">
                <FileNameTable :tdata="PPIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePPIChange"
                    :current-page.sync="currentPage1"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="ZS34">
                <FileNameTable :tdata="PPIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePPIChange"
                    :current-page.sync="currentPage1"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="ZS39">
                <FileNameTable :tdata="PPIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePPIChange"
                    :current-page.sync="currentPage1"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="ZSP2">
                <FileNameTable :tdata="PPIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePPIChange"
                    :current-page.sync="currentPage1"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-card>
      </div>
      <div class="table" v-if="type == 'cotton'">
        <div>
          <div class="top wrap1">
            <h1 style="font-size: 40px; font-weight: bold; color: #003164">
              Promoter proximal region interaction
            </h1>
          </div>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">COTTON PREDICTION RESULTS</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="A2">
                  <Table :tdata="cotton_ppi_pre_A2"></Table>
                </el-tab-pane>
                <el-tab-pane label="B1">
                  <Table :tdata="cotton_ppi_pre_B1"></Table>
                </el-tab-pane>
                <el-tab-pane label="C1">
                  <Table :tdata="cotton_ppi_pre_C1"></Table>
                </el-tab-pane>
                <el-tab-pane label="D5">
                  <Table :tdata="cotton_ppi_pre_D5"></Table>
                </el-tab-pane>
                <el-tab-pane label="E1">
                  <Table :tdata="cotton_ppi_pre_E1"></Table>
                </el-tab-pane>
                <el-tab-pane label="F1">
                  <Table :tdata="cotton_ppi_pre_F1"></Table>
                </el-tab-pane>
                <el-tab-pane label="G1">
                  <Table :tdata="cotton_ppi_pre_G1"></Table>
                </el-tab-pane>
                <el-tab-pane label="K2">
                  <Table :tdata="cotton_ppi_pre_K2"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">COTTON Interaction Information</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="A2">
                  <Table :tdata="cotton_ppi_res_A2"></Table>
                </el-tab-pane>
                <el-tab-pane label="B1">
                  <Table :tdata="cotton_ppi_res_B1"></Table>
                </el-tab-pane>
                <el-tab-pane label="C1">
                  <Table :tdata="cotton_ppi_res_C1"></Table>
                </el-tab-pane>
                <el-tab-pane label="D5">
                  <Table :tdata="cotton_ppi_res_D5"></Table>
                </el-tab-pane>
                <el-tab-pane label="E1">
                  <Table :tdata="cotton_ppi_res_E1"></Table>
                </el-tab-pane>
                <el-tab-pane label="F1">
                  <Table :tdata="cotton_ppi_res_F1"></Table>
                </el-tab-pane>
                <el-tab-pane label="G1">
                  <Table :tdata="cotton_ppi_res_G1"></Table>
                </el-tab-pane>
                <el-tab-pane label="K2">
                  <Table :tdata="cotton_ppi_res_K2"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">COTTON The Result Of PPI</span>
            </div>
            <div>
              <el-tabs
                tab-position="top"
                stretch
                @tab-click="changePPIFileList"
              >
                <el-tab-pane label="A2">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="B1">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="C1">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="D5">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="E1">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="F1">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="G1">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="K2">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <div class="top wrap1">
            <h1 style="font-size: 40px; font-weight: bold; color: #003164">
              Promoter distal element interaction
            </h1>
          </div>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">COTTON PREDICTION RESULTS</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="A2">
                  <Table :tdata="cotton_pdi_pre_A2"></Table>
                </el-tab-pane>
                <el-tab-pane label="B1">
                  <Table :tdata="cotton_pdi_pre_B1"></Table>
                </el-tab-pane>
                <el-tab-pane label="C1">
                  <Table :tdata="cotton_pdi_pre_C1"></Table>
                </el-tab-pane>
                <el-tab-pane label="D5">
                  <Table :tdata="cotton_pdi_pre_D5"></Table>
                </el-tab-pane>
                <el-tab-pane label="E1">
                  <Table :tdata="cotton_pdi_pre_E1"></Table>
                </el-tab-pane>
                <el-tab-pane label="F1">
                  <Table :tdata="cotton_pdi_pre_F1"></Table>
                </el-tab-pane>
                <el-tab-pane label="G1">
                  <Table :tdata="cotton_pdi_pre_G1"></Table>
                </el-tab-pane>
                <el-tab-pane label="K2">
                  <Table :tdata="cotton_pdi_pre_K2"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">COTTON Interaction Information</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="A2">
                  <el-tabs tab-position="top" stretch>
                    <el-tab-pane label="enhancer-enhancerdu">
                      <Table :tdata="cotton_pdi_res_A2_1"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="enhancer-genedu">
                      <Table :tdata="cotton_pdi_res_A2_2"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="gene-enhancerdu">
                      <Table :tdata="cotton_pdi_res_A2_3"></Table>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="B1">
                  <el-tabs tab-position="top" stretch>
                    <el-tab-pane label="enhancer-enhancerdu">
                      <Table :tdata="cotton_pdi_res_B1_1"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="enhancer-genedu">
                      <Table :tdata="cotton_pdi_res_B1_2"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="gene-enhancerdu">
                      <Table :tdata="cotton_pdi_res_B1_3"></Table>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="C1">
                  <el-tabs tab-position="top" stretch>
                    <el-tab-pane label="enhancer-enhancerdu">
                      <Table :tdata="cotton_pdi_res_C1_1"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="enhancer-genedu">
                      <Table :tdata="cotton_pdi_res_C1_2"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="gene-enhancerdu">
                      <Table :tdata="cotton_pdi_res_C1_3"></Table>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="D5">
                  <el-tabs tab-position="top" stretch>
                    <el-tab-pane label="enhancer-enhancerdu">
                      <Table :tdata="cotton_pdi_res_D5_1"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="enhancer-genedu">
                      <Table :tdata="cotton_pdi_res_D5_2"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="gene-enhancerdu">
                      <Table :tdata="cotton_pdi_res_D5_3"></Table>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="E1">
                  <el-tabs tab-position="top" stretch>
                    <el-tab-pane label="enhancer-enhancerdu">
                      <Table :tdata="cotton_pdi_res_E1_1"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="enhancer-genedu">
                      <Table :tdata="cotton_pdi_res_E1_2"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="gene-enhancerdu">
                      <Table :tdata="cotton_pdi_res_E1_3"></Table>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="F1">
                  <el-tabs tab-position="top" stretch>
                    <el-tab-pane label="enhancer-enhancerdu">
                      <Table :tdata="cotton_pdi_res_F1_1"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="enhancer-genedu">
                      <Table :tdata="cotton_pdi_res_F1_2"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="gene-enhancerdu">
                      <Table :tdata="cotton_pdi_res_F1_3"></Table>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="G1">
                  <el-tabs tab-position="top" stretch>
                    <el-tab-pane label="enhancer-enhancerdu">
                      <Table :tdata="cotton_pdi_res_G1_1"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="enhancer-genedu">
                      <Table :tdata="cotton_pdi_res_G1_2"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="gene-enhancerdu">
                      <Table :tdata="cotton_pdi_res_G1_3"></Table>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="K2">
                  <el-tabs tab-position="top" stretch>
                    <el-tab-pane label="enhancer-enhancerdu">
                      <Table :tdata="cotton_pdi_res_K2_1"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="enhancer-genedu">
                      <Table :tdata="cotton_pdi_res_K2_2"></Table>
                    </el-tab-pane>
                    <el-tab-pane label="gene-enhancerdu">
                      <Table :tdata="cotton_pdi_res_K2_3"></Table>
                    </el-tab-pane>
                  </el-tabs>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <el-card class="resTabs">
          <div slot="header">
            <span class="tableTitle">COTTON The Result Of PDI</span>
          </div>
          <div>
            <el-tabs tab-position="top" stretch @tab-click="changePDIFileList">
              <el-tab-pane label="A2">
                <FileNameTable :tdata="PDIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePDIChange"
                    :current-page.sync="currentPage2"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="B1">
                <FileNameTable :tdata="PDIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePDIChange"
                    :current-page.sync="currentPage2"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="C1">
                <FileNameTable :tdata="PDIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePDIChange"
                    :current-page.sync="currentPage2"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="D5">
                <FileNameTable :tdata="PDIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePDIChange"
                    :current-page.sync="currentPage2"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="E1">
                <FileNameTable :tdata="PDIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePDIChange"
                    :current-page.sync="currentPage2"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="F1">
                <FileNameTable :tdata="PDIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePDIChange"
                    :current-page.sync="currentPage2"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="G1">
                <FileNameTable :tdata="PDIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePDIChange"
                    :current-page.sync="currentPage2"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane label="K2">
                <FileNameTable :tdata="PDIfileName"></FileNameTable>
                <div>
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePDIChange"
                    :current-page.sync="currentPage2"
                    :page-size="10"
                    :page-count="50"
                    layout="total, prev, pager, next"
                  >
                  </el-pagination>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-card>
      </div>
      <div class="table" v-if="type == 'wheat'">
        <div>
          <div class="top wrap1">
            <h1 style="font-size: 40px; font-weight: bold; color: #003164">
              Promoter proximal region interaction
            </h1>
          </div>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">WHEAT PREDICTION RESULTS</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="wheat">
                  <Table :tdata="wheat_ppi_pre_wheat"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">WHEAT Interaction Information</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="wheat">
                  <Table :tdata="wheat_ppi_res_wheat"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">The Result Of WHEAT</span>
            </div>
            <div>
              <el-tabs
                tab-position="top"
                stretch
                @tab-click="changePPIFileList"
              >
                <el-tab-pane label="wheat_npy">
                  <FileNameTable :tdata="PPIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePPIChange"
                      :current-page.sync="currentPage1"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <div>
          <div class="top wrap1">
            <h1 style="font-size: 40px; font-weight: bold; color: #003164">
              Promoter distal element interaction
            </h1>
          </div>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">WHEAT PREDICTION RESULTS</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="wheat">
                  <Table :tdata="wheat_pdi_pre_wheat"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">WHEAT Interaction Information</span>
            </div>
            <div>
              <el-tabs tab-position="top" stretch>
                <el-tab-pane label="wheat">
                  <Table :tdata="wheat_pdi_res_wheat"></Table>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
          <el-card class="resTabs">
            <div slot="header">
              <span class="tableTitle">The Result Of WHEAT</span>
            </div>
            <div>
              <el-tabs
                tab-position="top"
                stretch
                @tab-click="changePDIFileList"
              >
                <el-tab-pane label="wheat_npy">
                  <FileNameTable :tdata="PDIfileName"></FileNameTable>
                  <div>
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handlePDIChange"
                      :current-page.sync="currentPage2"
                      :page-size="10"
                      :page-count="50"
                      layout="total, prev, pager, next"
                    >
                    </el-pagination>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <Back></Back>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { Loading } from "element-ui";
import Chart from "../components/Chart.vue";

function convertToElTableFormat(data) {
  const formattedData = [];

  // 获取所有列名
  const columns = Object.keys(data);

  // 假设以第一个列数据的长度为基准，保证所有列数据的长度一致
  const numRows = data[columns[0]].length;
  for (let i = 0; i < numRows; i++) {
    const row = {};
    for (const column of columns) {
      row[column] = data[column][i];
    }
    formattedData.push(row);
  }

  return formattedData;
}

function convertToCustomFormat(array) {
  const result = [];

  for (let i = 0; i < array.length; i++) {
    for (let j = 0; j < array[i].length; j++) {
      result.push([j, i, array[i][j]]);
    }
  }

  return result;
}

function verticalSum(arr) {
  const n = arr[0].length;
  const result = new Array(n).fill(0);

  for (let i = 0; i < 4; i++) {
    for (let j = 0; j < n; j++) {
      result[j] += arr[i][j];
    }
  }

  return result;
}
// 因为列是自动生成的，所以在这里调整pre的顺序(他妈死了，谁家这么渲染列表，这谁的屎山)
// function lastpre(data) {
//   const preValue = data.Prediction;
//   delete data.Prediction;
//   data.Prediction = preValue;
//   return data;
// }
export default {
  name: "Result",
  components: { Chart },
  data() {
    return {
      type: "maize",
      predictions_ppi_ear: [],
      predictions_ppi_in_shoot: [],
      predictions_ppi_in_py: [],
      predictions_ppi_in_tassel: [],
      predictions_ppi_in_ear: [],
      maize_pdi_pre_ear: [],
      maize_pdi_pre_py: [],
      maize_pdi_pre_shoot: [],
      maize_pdi_res_ear: [],
      maize_pdi_res_py: [],
      maize_pdi_res_shoot: [],
      ear: [],
      in_ear: [],
      in_tassel: [],
      py: [],
      shoot: [],
      PPIfileName: [],
      PDIfileName: [],
      // ppi
      maize_ppi_filenameLabel: "",
      rice_ppi_filenameLabel: "",
      cotton_ppi_filenameLabel: "",
      wheat_ppi_filenameLabel: "",
      // pdi
      maize_pdi_filenameLabel: "",
      rice_pdi_filenameLabel: "",
      cotton_pdi_filenameLabel: "",
      wheat_pdi_filenameLabel: "",
      // maize_ppi
      page1: 1,
      limit1: 10,
      total1: 0,
      currentPage1: 1,
      // maize_pdi
      page2: 1,
      limit2: 10,
      total2: 0,
      currentPage2: 1,

      rice_pre_MH_H3K4: [],
      rice_pre_MH_H3K9: [],
      rice_pre_MH_RNAP2: [],
      rice_pre_ZS_H3K4: [],
      rice_pre_ZS_H3K9: [],
      rice_pre_ZS_RNAP2: [],
      rice_res_MH63_H3K4me3: [],
      rice_res_MH63_H3K9me2: [],
      rice_res_MH63_RNAP2: [],
      rice_res_ZS_H3K4: [],
      rice_res_ZS_H3K9: [],
      rice_res_ZS_RNAP2: [],

      cotton_ppi_pre_A2: [],
      cotton_ppi_pre_B1: [],
      cotton_ppi_pre_C1: [],
      cotton_ppi_pre_D5: [],
      cotton_ppi_pre_E1: [],
      cotton_ppi_pre_F1: [],
      cotton_ppi_pre_G1: [],
      cotton_ppi_pre_K2: [],

      cotton_ppi_res_A2: [],
      cotton_ppi_res_B1: [],
      cotton_ppi_res_C1: [],
      cotton_ppi_res_D5: [],
      cotton_ppi_res_E1: [],
      cotton_ppi_res_F1: [],
      cotton_ppi_res_G1: [],
      cotton_ppi_res_K2: [],

      cotton_pdi_pre_A2: [],
      cotton_pdi_pre_B1: [],
      cotton_pdi_pre_C1: [],
      cotton_pdi_pre_D5: [],
      cotton_pdi_pre_E1: [],
      cotton_pdi_pre_F1: [],
      cotton_pdi_pre_G1: [],
      cotton_pdi_pre_K2: [],

      cotton_pdi_res_A2_1: [],
      cotton_pdi_res_A2_2: [],
      cotton_pdi_res_A2_3: [],
      cotton_pdi_res_B1_1: [],
      cotton_pdi_res_B1_2: [],
      cotton_pdi_res_B1_3: [],
      cotton_pdi_res_C1_1: [],
      cotton_pdi_res_C1_2: [],
      cotton_pdi_res_C1_3: [],
      cotton_pdi_res_D5_1: [],
      cotton_pdi_res_D5_2: [],
      cotton_pdi_res_D5_3: [],
      cotton_pdi_res_E1_1: [],
      cotton_pdi_res_E1_2: [],
      cotton_pdi_res_E1_3: [],
      cotton_pdi_res_F1_1: [],
      cotton_pdi_res_F1_2: [],
      cotton_pdi_res_F1_3: [],
      cotton_pdi_res_G1_1: [],
      cotton_pdi_res_G1_2: [],
      cotton_pdi_res_G1_3: [],
      cotton_pdi_res_K2_1: [],
      cotton_pdi_res_K2_2: [],
      cotton_pdi_res_K2_3: [],

      wheat_ppi_pre_wheat: [],
      wheat_pdi_pre_wheat: [],
      wheat_ppi_res_wheat: [],
      wheat_pdi_res_wheat: [],
      cotton_res_label: "",
      Loading: false,
    };
  },
  methods: {
    async changeType(ty) {
      this.Loading = true;
      this.type = ty;

      // let rediv = document.getElementById(this.type);
      // rediv.classList.remove("active");
      // let div = document.getElementById(ty);
      // div.classList.add("active");

      await this.getdata(ty);
    },
    async getdata(project) {
      let tableData1, tableData2, tableData3, tableData4;
      if (project === "maize") {
        // subtype === ppi type === 'pre' || 'res'
        tableData1 = await this.$API.reqResultInfo(project, "ppi", "pre");
        tableData2 = await this.$API.reqResultInfo(project, "ppi", "res");
        // console.log(convertToElTableFormat(tableData1["predictions_ppi_ear.csv"]));
        this.predictions_ppi_ear = convertToElTableFormat(
          tableData1["Ear(Li et al. 2019).csv"]
        );
        this.predictions_ppi_in_ear = convertToElTableFormat(
          tableData1["Ear(Sun et al. 2020).csv"]
        );
        this.predictions_ppi_in_tassel = convertToElTableFormat(
          tableData1["Tassel(Sun et al. 2020).csv"]
        );
        this.predictions_ppi_in_py = convertToElTableFormat(
          tableData1["Shoot(Peng et al. 2019).csv"]
        );
        this.predictions_ppi_in_shoot = convertToElTableFormat(
          tableData1["Shoot(Li et al. 2019).csv"]
        );

        this.ear = convertToElTableFormat(tableData2["Ear(Li et al. 2019).csv"]);
        this.in_ear = convertToElTableFormat(tableData2["Ear(Sun et al. 2020).csv"]);
        this.in_tassel = convertToElTableFormat(tableData2["Tassel(Sun et al. 2020).csv"]);
        this.py = convertToElTableFormat(tableData2["Shoot(Peng et al. 2019).csv"]);
        this.shoot = convertToElTableFormat(tableData2["Shoot(Li et al. 2019).csv"]);

        this.changePPIFileList();

        // subtype === pdi type === 'pre' || 'res'
        tableData3 = await this.$API.reqResultInfo(project, "pdi", "pre");
        tableData4 = await this.$API.reqResultInfo(project, "pdi", "res");
        this.maize_pdi_pre_ear = convertToElTableFormat(
          tableData3["Ear(Li et al. 2019).csv"]
        );
        this.maize_pdi_pre_py = convertToElTableFormat(
          tableData3["Shoot(Peng et al. 2019).csv"]
        );
        this.maize_pdi_pre_shoot = convertToElTableFormat(
          tableData3["Shoot(Li et al. 2019).csv"]
        );

        this.maize_pdi_res_ear = convertToElTableFormat(tableData4["Ear(Li et al. 2019).csv"]);
        this.maize_pdi_res_py = convertToElTableFormat(tableData4["Shoot(Peng et al. 2019).csv"]);
        this.maize_pdi_res_shoot = convertToElTableFormat(
          tableData4["Shoot(Li et al. 2019).csv"]
        );

        this.changePDIFileList();
        this.Loading = false;
      } else if (project === "rice") {
        tableData1 = await this.$API.reqResultInfo(project, "", "pre");
        tableData2 = await this.$API.reqResultInfo(project, "", "res");
        this.rice_pre_MH_H3K4 = convertToElTableFormat(
          tableData1["predictions_rice_MH_H3K4.csv"]
        );
        this.rice_pre_MH_H3K9 = convertToElTableFormat(
          tableData1["predictions_rice_MH_H3K9.csv"]
        );
        this.rice_pre_MH_RNAP2 = convertToElTableFormat(
          tableData1["predictions_rice_MH_RNAP2.csv"]
        );
        this.rice_pre_ZS_H3K4 = convertToElTableFormat(
          tableData1["predictions_rice_ZS_H3K4.csv"]
        );
        this.rice_pre_ZS_H3K9 = convertToElTableFormat(
          tableData1["predictions_rice_ZS_H3K9.csv"]
        );
        this.rice_pre_ZS_RNAP2 = convertToElTableFormat(
          tableData1["predictions_rice_ZS_RNAP2.csv"]
        );
        this.rice_res_MH63_H3K4me3 = convertToElTableFormat(
          tableData2["MH63.H3K4me3.csv"]
        );
        this.rice_res_MH63_H3K9me2 = convertToElTableFormat(
          tableData2["MH63.H3K9me2.csv"]
        );
        this.rice_res_MH63_RNAP2 = convertToElTableFormat(
          tableData2["MH63.RNAP2.csv"]
        );
        this.rice_res_ZS_H3K4 = convertToElTableFormat(
          tableData2["ZS_H3K4.csv"]
        );
        this.rice_res_ZS_H3K9 = convertToElTableFormat(
          tableData2["ZS_H3K9.csv"]
        );
        this.rice_res_ZS_RNAP2 = convertToElTableFormat(
          tableData2["ZS_RNAP2.csv"]
        );
        this.changePPIFileList();
        this.Loading = false;
      } else if (project === "cotton") {
        tableData1 = await this.$API.reqResultInfo(project, "ppi", "pre");

        this.cotton_ppi_pre_A2 = convertToElTableFormat(
          tableData1["predictions_cotton_ppi_A2.csv"]
        );
        this.cotton_ppi_pre_B1 = convertToElTableFormat(
          tableData1["predictions_cotton_ppi_B1.csv"]
        );
        this.cotton_ppi_pre_C1 = convertToElTableFormat(
          tableData1["predictions_cotton_ppi_C1.csv"]
        );
        this.cotton_ppi_pre_D5 = convertToElTableFormat(
          tableData1["predictions_cotton_ppi_D5.csv"]
        );
        this.cotton_ppi_pre_E1 = convertToElTableFormat(
          tableData1["predictions_cotton_ppi_E1.csv"]
        );
        this.cotton_ppi_pre_F1 = convertToElTableFormat(
          tableData1["predictions_cotton_ppi_F1.csv"]
        );
        this.cotton_ppi_pre_G1 = convertToElTableFormat(
          tableData1["predictions_cotton_ppi_G1.csv"]
        );
        this.cotton_ppi_pre_K2 = convertToElTableFormat(
          tableData1["predictions_cotton_ppi_K2.csv"]
        );

        let tableData28 = await this.$API.reqCottonResInfo ("A2","ppi", "gene-genedu.csv");
        this.cotton_ppi_res_A2 = convertToElTableFormat(
          tableData28["A2"]
        );
        let tableData29 = await this.$API.reqCottonResInfo ("B1","ppi", "gene-genedu.csv");
        this.cotton_ppi_res_B1 = convertToElTableFormat(
          tableData29["B1"]
        );
        let tableData30 = await this.$API.reqCottonResInfo ("C1","ppi", "gene-genedu.csv");
        this.cotton_ppi_res_C1 = convertToElTableFormat(
          tableData30["C1"]
        );
        let tableData31 = await this.$API.reqCottonResInfo ("D5","ppi", "gene-genedu.csv");
        this.cotton_ppi_res_D5 = convertToElTableFormat(
          tableData31["D5"]
        );
        let tableData32 = await this.$API.reqCottonResInfo ("E1","ppi", "gene-genedu.csv");
        this.cotton_ppi_res_E1 = convertToElTableFormat(
          tableData32["E1"]
        );
        let tableData33 = await this.$API.reqCottonResInfo ("F1","ppi", "gene-genedu.csv");
        this.cotton_ppi_res_F1 = convertToElTableFormat(
          tableData33["F1"]
        );
        let tableData34 = await this.$API.reqCottonResInfo ("G1","ppi", "gene-genedu.csv");
        this.cotton_ppi_res_G1 = convertToElTableFormat(
          tableData34["G1"]
        );
        let tableData35 = await this.$API.reqCottonResInfo ("K2","ppi", "gene-genedu.csv");
        this.cotton_ppi_res_K2 = convertToElTableFormat(
          tableData35["K2"]
        );
        this.changePPIFileList();
        // subtype === pdi type === 'pre' || 'res'
        tableData3 = await this.$API.reqResultInfo(project, "pdi", "pre");
        this.cotton_pdi_pre_A2 = convertToElTableFormat(
          tableData3["predictions_cotton_pdi_A2.csv"]
        );
        this.cotton_pdi_pre_B1 = convertToElTableFormat(
          tableData3["predictions_cotton_pdi_B1.csv"]
        );
        this.cotton_pdi_pre_C1 = convertToElTableFormat(
          tableData3["predictions_cotton_pdi_C1.csv"]
        );
        this.cotton_pdi_pre_D5 = convertToElTableFormat(
          tableData3["predictions_cotton_pdi_D5.csv"]
        );
        this.cotton_pdi_pre_E1 = convertToElTableFormat(
          tableData3["predictions_cotton_pdi_E1.csv"]
        );
        this.cotton_pdi_pre_F1 = convertToElTableFormat(
          tableData3["predictions_cotton_pdi_F1.csv"]
        );
        this.cotton_pdi_pre_G1 = convertToElTableFormat(
          tableData3["predictions_cotton_pdi_G1.csv"]
        );
        this.cotton_pdi_pre_K2 = convertToElTableFormat(
          tableData3["predictions_cotton_pdi_K2.csv"]
        );

        tableData4 = await this.$API.reqCottonResInfo("A2", "pdi", "enhancer-enhancerdu.csv");
        let tableData5 = await this.$API.reqCottonResInfo("A2", "pdi", "enhancer-genedu.csv");
        let tableData6 = await this.$API.reqCottonResInfo("A2", "pdi", "gene-enhancerdu.csv");
        this.cotton_pdi_res_A2_1 = convertToElTableFormat(tableData4["A2"])
        this.cotton_pdi_res_A2_2 = convertToElTableFormat(tableData5["A2"])
        this.cotton_pdi_res_A2_3 = convertToElTableFormat(tableData6["A2"])

        let tableData7 = await this.$API.reqCottonResInfo("B1", "pdi", "enhancer-enhancerdu.csv");
        let tableData8 = await this.$API.reqCottonResInfo("B1", "pdi", "enhancer-genedu.csv");
        let tableData9 = await this.$API.reqCottonResInfo("B1", "pdi", "gene-enhancerdu.csv");
        this.cotton_pdi_res_B1_1 = convertToElTableFormat(tableData7["B1"])
        this.cotton_pdi_res_B1_2 = convertToElTableFormat(tableData8["B1"])
        this.cotton_pdi_res_B1_3 = convertToElTableFormat(tableData9["B1"])

        let tableData10 = await this.$API.reqCottonResInfo("C1", "pdi", "enhancer-enhancerdu.csv");
        let tableData11 = await this.$API.reqCottonResInfo("C1", "pdi", "enhancer-genedu.csv");
        let tableData12 = await this.$API.reqCottonResInfo("C1", "pdi", "gene-enhancerdu.csv");
        this.cotton_pdi_res_C1_1 = convertToElTableFormat(tableData10["C1"])
        this.cotton_pdi_res_C1_2 = convertToElTableFormat(tableData11["C1"])
        this.cotton_pdi_res_C1_3 = convertToElTableFormat(tableData12["C1"])

        let tableData13 = await this.$API.reqCottonResInfo("D5", "pdi", "enhancer-enhancerdu.csv");
        let tableData14 = await this.$API.reqCottonResInfo("D5", "pdi", "enhancer-genedu.csv");
        let tableData15 = await this.$API.reqCottonResInfo("D5", "pdi", "gene-enhancerdu.csv");
        this.cotton_pdi_res_D5_1 = convertToElTableFormat(tableData13["D5"])
        this.cotton_pdi_res_D5_2 = convertToElTableFormat(tableData14["D5"])
        this.cotton_pdi_res_D5_3 = convertToElTableFormat(tableData15["D5"])

        let tableData16 = await this.$API.reqCottonResInfo("E1", "pdi", "enhancer-enhancerdu.csv");
        let tableData17 = await this.$API.reqCottonResInfo("E1", "pdi", "enhancer-genedu.csv");
        let tableData18 = await this.$API.reqCottonResInfo("E1", "pdi", "gene-enhancerdu.csv");
        this.cotton_pdi_res_E1_1 = convertToElTableFormat(tableData16["E1"])
        this.cotton_pdi_res_E1_2 = convertToElTableFormat(tableData17["E1"])
        this.cotton_pdi_res_E1_3 = convertToElTableFormat(tableData18["E1"])

        let tableData19 = await this.$API.reqCottonResInfo("F1", "pdi", "enhancer-enhancerdu.csv");
        let tableData20 = await this.$API.reqCottonResInfo("F1", "pdi", "enhancer-genedu.csv");
        let tableData21 = await this.$API.reqCottonResInfo("F1", "pdi", "gene-enhancerdu.csv");
        this.cotton_pdi_res_F1_1 = convertToElTableFormat(tableData19["F1"])
        this.cotton_pdi_res_F1_2 = convertToElTableFormat(tableData20["F1"])
        this.cotton_pdi_res_F1_3 = convertToElTableFormat(tableData21["F1"])

        let tableData22 = await this.$API.reqCottonResInfo("G1", "pdi", "enhancer-enhancerdu.csv");
        let tableData23 = await this.$API.reqCottonResInfo("G1", "pdi", "enhancer-genedu.csv");
        let tableData24 = await this.$API.reqCottonResInfo("G1", "pdi", "gene-enhancerdu.csv");
        this.cotton_pdi_res_G1_1 = convertToElTableFormat(tableData22["G1"])
        this.cotton_pdi_res_G1_2 = convertToElTableFormat(tableData23["G1"])
        this.cotton_pdi_res_G1_3 = convertToElTableFormat(tableData24["G1"])

        let tableData25 = await this.$API.reqCottonResInfo("K2", "pdi", "enhancer-enhancerdu.csv");
        let tableData26 = await this.$API.reqCottonResInfo("K2", "pdi", "enhancer-genedu.csv");
        let tableData27 = await this.$API.reqCottonResInfo("K2", "pdi", "gene-enhancerdu.csv");
        this.cotton_pdi_res_K2_1 = convertToElTableFormat(tableData25["K2"])
        this.cotton_pdi_res_K2_2 = convertToElTableFormat(tableData26["K2"])
        this.cotton_pdi_res_K2_3 = convertToElTableFormat(tableData27["K2"])

        this.changePDIFileList();
        this.Loading = false;
      } else if (project === "wheat") {
        tableData1 = await this.$API.reqResultInfo(project, "ppi", "pre");
        tableData2 = await this.$API.reqResultInfo(project, "ppi", "res");
        this.wheat_ppi_pre_wheat = convertToElTableFormat(
          tableData1["predictions_wheat_ppi_wheat.csv"]
        );
        this.wheat_ppi_res_wheat = convertToElTableFormat(
          tableData2["wheat_ppi.csv"]
        );
        this.changePPIFileList();
        // subtype === pdi type === 'pre' || 'res'
        tableData3 = await this.$API.reqResultInfo(project, "pdi", "pre");
        tableData4 = await this.$API.reqResultInfo(project, "pdi", "res");
        this.wheat_pdi_pre_wheat = convertToElTableFormat(
          tableData3["predictions_wheat_pdi_wheat.csv"]
        );
        this.wheat_pdi_res_wheat = convertToElTableFormat(
          tableData4["wheat_pdi.csv"]
        );
        this.changePDIFileList();
        this.Loading = false;
      }
    },
    // 获取热力图全部文件名，PPI专用
    async getPPIFileNameData(params) {
      let sample = params.sample;
      let obj = { ...params };
      let data = await this.$API.reqFileNameInfo(obj);
      // console.log(data);
      this.PPIfileName = data[sample];
    },
    // 获取热力图全部文件名，PDI专用
    async getPDIFileNameData(params) {
      let sample = params.sample;
      let obj = { ...params };
      let data = await this.$API.reqFileNameInfo(obj);
      // console.log(data);
      this.PDIfileName = data[sample];
    },
    // 切换热力图？
    async changeMaizeHot(tab, event) {
      if (tab.label == "PPIgene1") {
        await this.getMaizeHot(0);
      } else if (tab.label == "PPIgene2") {
        await this.getMaizeHot(1);
      }
    },
    // 切换filename的tabs,PPI专用
    changePPIFileList(tab, event) {
      if (this.type === "maize") {
        if (!tab) {
          this.maize_ppi_filenameLabel = "Ear(Li et al. 2019)";
        } else {
          this.maize_ppi_filenameLabel = tab.label;
        }
      } else if (this.type === "rice") {
        if (!tab) {
          this.rice_ppi_filenameLabel = "MH34";
        } else {
          this.rice_ppi_filenameLabel = tab.label;
        }
      } else if (this.type === "cotton") {
        if (!tab) {
          this.cotton_ppi_filenameLabel = "A2";
        } else {
          this.cotton_ppi_filenameLabel = tab.label;
        }
      } else if (this.type === "wheat") {
        if (!tab) {
          this.wheat_ppi_filenameLabel = "wheat_npy";
        } else {
          this.wheat_ppi_filenameLabel = "wheat_npy";
        }
      }
      this.handlePPIChange(1);
    },
    // 切换filename的tabs,PDI专用
    changePDIFileList(tab, event) {
      if (this.type === "maize") {
        if (!tab) {
          this.maize_pdi_filenameLabel = "Ear(Li et al. 2019)";
        } else {
          this.maize_pdi_filenameLabel = tab.label;
        }
      } else if (this.type === "rice") {
        if (!tab) {
          this.rice_pdi_filenameLabel = "MH34";
        } else {
          this.rice_pdi_filenameLabel = tab.label;
        }
      } else if (this.type === "cotton") {
        if (!tab) {
          this.cotton_pdi_filenameLabel = "A2";
        } else {
          this.cotton_pdi_filenameLabel = tab.label;
        }
      } else if (this.type === "wheat") {
        if (!tab) {
          this.wheat_pdi_filenameLabel = "wheat_npy";
        } else {
          this.wheat_pdi_filenameLabel = "wheat_npy";
        }
      }
      this.handlePDIChange(1);
    },
    handleSizeChange(val) {
      console.log(val);
    },
    // PPI翻页
    handlePPIChange(val) {
      this.page1 = val;
      this.currentPage1 = val;
      let params = null;
      if (this.type === "maize") {
        params = {
          project: this.type,
          subtype: "ppi",
          sample: this.maize_ppi_filenameLabel,
          page: this.page1,
          limit: this.limit1,
        };
      } else if (this.type === "rice") {
        params = {
          project: this.type,
          subtype: "",
          sample: this.rice_ppi_filenameLabel,
          page: this.page1,
          limit: this.limit1,
        };
      } else if (this.type === "cotton") {
        params = {
          project: this.type,
          subtype: "ppi",
          sample: this.cotton_ppi_filenameLabel,
          page: this.page1,
          limit: this.limit1,
        };
      } else if (this.type === "wheat") {
        params = {
          project: this.type,
          subtype: "ppi",
          sample: this.wheat_ppi_filenameLabel,
          page: this.page1,
          limit: this.limit1,
        };
      }
      // console.log(params);
      this.getPPIFileNameData(params);
    },
    // PDI翻页
    handlePDIChange(val) {
      this.page2 = val;
      this.currentPage2 = val;
      let params = null;
      if (this.type === "maize") {
        params = {
          project: this.type,
          subtype: "pdi",
          sample: this.maize_pdi_filenameLabel,
          page: this.page2,
          limit: this.limit2,
        };
      } else if (this.type === "rice") {
        params = {
          project: this.type,
          subtype: "",
          sample: this.rice_pdi_filenameLabel,
          page: this.page2,
          limit: this.limit2,
        };
      } else if (this.type === "cotton") {
        params = {
          project: this.type,
          subtype: "pdi",
          sample: this.cotton_pdi_filenameLabel,
          page: this.page2,
          limit: this.limit2,
        };
      } else if (this.type === "wheat") {
        params = {
          project: this.type,
          subtype: "pdi",
          sample: this.wheat_pdi_filenameLabel,
          page: this.page2,
          limit: this.limit2,
        };
      }
      this.getPDIFileNameData(params);
    },
  },
  created() {
    // this.getTable();

    this.changeType("maize");

    // console.log(this.ppi_seq1.gradient!=undefined)
  },
};
</script>

<style scoped src="../assets/css/style.css"></style>

<style scoped>
.result {
  /* height: 80%; */
  /* text-align: center; */
  width: 80%;
  margin: 0 auto;
}
.top {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin: 15px;
  margin: 0 auto;
  height: 70px;
  margin-top: 50px;
  /* background:-webkit-linear-gradient(top,#A3EFE6,#C3EAEF) ; */
  border-radius: 8px;
}
.table {
  margin-bottom: 45px;
}

::v-deep .el-tabs__nav-scroll {
  width: 100%;
  margin: 0 auto;
}
/* ::v-deep .el-tabs__item {
  font-size: 20px;
} */

.resTabs {
  margin-top: 30px;
  margin-bottom: 20px;
  /* width: 80%;
  margin: 0 auto; */
}
.tableTitle {
  margin-left: 20px;
  /* margin: auto; */
  font-size: 20px;
  font-weight: bold;
  /* color:#FB636F ; */
}

.active {
  /* background: #f7c35f !important; */
  background: #42b983 !important;
}
.active h5 {
  color: #04000b;
}
.product-list-box {
  max-width: 900px;
}
</style>
